import { Box, CircularProgress } from "@mui/material";
import { flexRowCont } from "../../../common/styles/manage-accessibility-action";
import { emptyCont } from "../sxprops";

export const CenteredLoadingIndicator: React.FC = () => {
  return (
    <Box
      sx={{
        padding: 5,
        ...emptyCont,
      }}
    >
      <CircularProgress />
    </Box>
  );
};
